import * as _ from 'lodash';

export function replaceItems<T = any, U = T>(
    source: T[],
    updatedItem: U,
    comparator: (item: T, index?: number) => boolean,
    shouldAddIfMissing = false
) {
    if (!shouldAddIfMissing) {
        return source.map((item, index) => (comparator(item, index) ? updatedItem : item));
    }

    if (_.isEmpty(source)) {
        return [updatedItem];
    }

    const updateOrAddMissingItem = (updatedSource, item, index, originalSource) => {
        const isItemToReplace = comparator(item, index);

        if (index === originalSource.length - 1 && !isItemToReplace) {
            return [...updatedSource, item, updatedItem];
        }

        return isItemToReplace ? [...updatedSource, updatedItem] : [...updatedSource, item];
    };

    return source.reduce(updateOrAddMissingItem, []);
}
